import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";
import { store } from "../../utils/store";

export type CallingReportQuery = {
  period?: string;
  from?: string;
  to?: string;
  rowBy?: string;
  teamIds?: string[];
  agentIds?: string[];
  projectIds?: string[];
  sources?: string[];
  formIds?: string[];
  stages?: string[];
};

function withOrg(qs: URLSearchParams) {
  const orgId = String(store.getState().auth?.activeOrganizationId || "").trim();
  qs.set(
    "organizationId",
    !orgId || orgId === "all" || orgId === "*" ? "all" : orgId
  );
  return qs;
}

export function callingReportQueryString(params: CallingReportQuery) {
  const qs = withOrg(new URLSearchParams());
  if (params.period) qs.set("period", params.period);
  if (params.from) qs.set("from", params.from);
  if (params.to) qs.set("to", params.to);
  if (params.rowBy) qs.set("rowBy", params.rowBy);
  if (params.teamIds?.length) qs.set("teamIds", params.teamIds.join(","));
  if (params.agentIds?.length) qs.set("agentIds", params.agentIds.join(","));
  if (params.projectIds?.length) qs.set("projectIds", params.projectIds.join(","));
  if (params.sources?.length) qs.set("sources", params.sources.join(","));
  if (params.formIds?.length) qs.set("formIds", params.formIds.join(","));
  if (params.stages?.length) qs.set("stages", params.stages.join(","));
  return qs;
}

export async function getCallingFilters() {
  const callParams = await getCallParams("GET");
  return makeCall(
    `${urls.CALLINGREPORTFILTERS}?${withOrg(new URLSearchParams()).toString()}`,
    callParams
  );
}

export async function getCallingReport(params: CallingReportQuery) {
  const callParams = await getCallParams("GET");
  return makeCall(
    `${urls.CALLINGREPORT}?${callingReportQueryString(params).toString()}`,
    callParams,
    60000
  );
}

export async function getCallingReportLeads(
  params: CallingReportQuery & {
    agentId?: string;
    date?: string;
    kind?: string;
    bucket?: string;
  }
) {
  const callParams = await getCallParams("GET");
  const qs = callingReportQueryString(params);
  if (params.agentId) qs.set("agentId", params.agentId);
  if (params.date) qs.set("date", params.date);
  if (params.kind) qs.set("kind", params.kind);
  if (params.bucket) qs.set("bucket", params.bucket);
  return makeCall(`${urls.CALLINGREPORTLEADS}?${qs.toString()}`, callParams, 60000);
}

export async function exportCallingReport(params: CallingReportQuery) {
  const callParams = await getCallParams("GET");
  const res = await fetch(
    `${urls.CALLINGREPORTEXPORT}?${callingReportQueryString(params).toString()}`,
    callParams as RequestInit
  );
  if (!res.ok) {
    throw new Error("Could not download the calling report");
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `daily-calling-report-${new Date().toISOString().slice(0, 10)}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}
